import React, { useEffect } from 'react'
import { Modal, ModalHeader } from '@vibe/core'
import { Flex, Box } from '@vibe/layout'
import { Text } from '@vibe/typography'
import { BASE_API_URL } from '../utils/constants'

const LoginModal = ({ show, onClose, boardId, onSuccess, sessionToken }) => {
  useEffect(() => {
    const handleMessage = (event) => {
      // Basic security check: you might want to verify event.origin here
      if (event.data === 'auth-success') {
        onSuccess();
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onSuccess]);

  const handleGoogleLogin = async () => {
    try {
      const response = await fetch(
        `${BASE_API_URL}/auth/google?board_id=${boardId}`,
        {
          headers: {
            'Authorization': `Bearer ${sessionToken}`,
            'ngrok-skip-browser-warning': '69420'
          }
        }
      )
      const data = await response.json()
      if (data.success && data.data.auth_url) {
        // Open auth URL in a new window
        const width = 600;
        const height = 700;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        
        const authWindow = window.open(
          data.data.auth_url,
          'google-auth',
          `width=${width},height=${height},left=${left},top=${top}`
        );
      }
    } catch (error) {
      console.error('Error initiating Google auth:', error)
    }
  }

  const handleMicrosoftLogin = async () => {
    try {
      const response = await fetch(
        `${BASE_API_URL}/auth/microsoft?board_id=${boardId}`,
        {
          headers: {
            'Authorization': `Bearer ${sessionToken}`,
            'ngrok-skip-browser-warning': '69420'
          }
        }
      )
      const data = await response.json()
      if (data.success && data.data.auth_url) {
        const width = 600;
        const height = 700;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2;
        
        const authWindow = window.open(
          data.data.auth_url,
          'microsoft-auth',
          `width=${width},height=${height},left=${left},top=${top}`
        );
      }
    } catch (error) {
      console.error('Error initiating Microsoft auth:', error)
    }
  }
  return (
    <Modal
      id="login-account-modal"
      title="Select sender account"
      show={show}
      onClose={onClose}
      width={450}
    >
      <ModalHeader title="Hidden" className="hidden-vibe-header" />
      <Box style={{ padding: '32px', backgroundColor: '#fff', borderRadius: 16 }}>
        <Flex direction="column" gap={16} style={{ width: '100%' }}>
          {/* Google Sign In */}
          <button
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 12,
              padding: '12px 24px',
              backgroundColor: '#fff',
              border: '1px solid #E5E7EB',
              borderRadius: 8,
              fontSize: 16,
              fontWeight: 500,
              color: '#323338',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
              fontFamily: 'inherit'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#F9FAFB'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#fff'}
            onClick={handleGoogleLogin}
          >
            <svg width="20" height="20" viewBox="0 0 24 24">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4" />
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05" />
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
            </svg>
            Sign in with Google
          </button>

          {/* Microsoft Sign In */}
          <button
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 12,
              padding: '12px 24px',
              backgroundColor: '#fff',
              border: '1px solid #E5E7EB',
              borderRadius: 8,
              fontSize: 16,
              fontWeight: 500,
              color: '#323338',
              cursor: 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
              fontFamily: 'inherit'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#F9FAFB'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#fff'}
            onClick={handleMicrosoftLogin}
          >
            <svg width="20" height="20" viewBox="0 0 23 23">
              <path fill="#f3f3f3" d="M0 0h23v23H0z" />
              <path fill="#f35325" d="M1 1h10v10H1z" />
              <path fill="#81bc06" d="M12 1h10v10H12z" />
              <path fill="#05a6f0" d="M1 12h10v10H1z" />
              <path fill="#ffba08" d="M12 12h10v10H12z" />
            </svg>
            Sign in with Microsoft
          </button>

          {/* Hint Box */}
          <div style={{
            marginTop: 12,
            padding: '12px 16px',
            backgroundColor: '#E1F2FF',
            borderRadius: 8,
            border: '1px solid #CDE7FF',
            width: '100%',
            boxSizing: 'border-box'
          }}>
            <p style={{
              fontSize: '14px',
              color: '#00529B',
              lineHeight: '1.4',
              textAlign: 'center',
              fontWeight: 500,
              margin: 0,
              width: '100%',
              fontFamily: 'inherit'
            }}>
              Make sure to tick all the checkboxes when authorizing your account
            </p>
          </div>
        </Flex>
      </Box>
    </Modal>
  )
}

export default LoginModal
